import {
    addItemToCollection,
} from "directus/src/operations";

export async function createBookmark(item) {
    try {
        const response = await addItemToCollection("bookmark_links", item);
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
}